/**
 * state format
 *  .gui
 *      .responsive {String}
 *          ['desktop',|'mobile']
 *      .currentStep {Number}
 *      .currentStepTitle {String}
 *  .user
 *      .address
 *      .email
 *  .configuration
 *      .roofArea {Number}
 *      .roofInclination {Number}
 *      .electricityConsumption {String}
 *      .houseUsage {String}
 *  .map
 *      .refs
 *          .map {google.maps.Map}
 *          .polygon {google.maps.Polygon}
 *      .data {Object}
 *          ...
 *      .staticImageUrl {String}
 */

export default {
    applicationContext: {
        ch: null,
        ss: null,
        cmp: null,
        fullLocationSearchString: null
    },
    gui: {
        responsive: null,
        currentStep: null,
        currentStepTitle: null,
        currentEditingData: null,
        onpopstateListeners: {},
        nextPermissionListeners: {},
        wizardNextautoWatchers: {},
        wizardButtonNavClicked: false
    },
    user: {
        address: null,
        pv: null,
        city: null,
        postalCode: null,
        email: null
    },
    configuration: {
        systemCoords: {
            lat: null,
            lng: null
        },
        powerFTV: null,
        electricityConsumption: null,
        electricityConsumptionCost: null,
        houseUsage: null
    },
    map: {
        refs: {
            map: null,
            polygon: null,
            marker: null
        },
        data: null,
        staticImageUrl: null
    },
    /**
     * Holds the quotations state
     */
    quotations: {
        uuid: null, // 'bff78db4-c7af-4dd1-bab8-7165d305fd02'
        selectedQuotation: null, // ['kwh5'|'kwh10']
        selectedImpianto: null, // ['kwh5'|'kwh10']
        advisedImpianto: null, // ['kwh5'|'kwh10']
        kwh5: {
            total: null
        },
        kwh10: {
            total: null
        }
    },
    quotationsForm: {
        valid: false,
        nome: null,
        cognome: null,
        ragioneSociale: null,
        cfpiva: null,
        email: null,
        telefono: null,
        tipoImmobile: null,
        consensoReadPrivacy: null,
        consensoAuthorizeA: null,
        consensoAuthorizeB: null,
        consensoAuthorizeC: null,
        consensoAuthorizeD: null
    }
};